import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseUrlHelperService } from '../helper/baseUrlHelper.service';
import { NbcLoggerService } from '../logger/nbc-logger.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class StudioPayrollService {

  constructor(
    private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private log: NbcLoggerService) { }

  
  get(query:any): Observable<any> {
    this.log.trace("search: " + query.eventId);
    return this.http.post(this._apiroot.baseUrl + "talentPayroll/paymentExport/GetExports", query).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  };

  downloadFile(query:any): Observable<any> {
    this.log.trace("search: " + query.eventId);
    return this.http.post(this._apiroot.baseUrl + "talentPayroll/paymentExport/DownloadExport", query,
      {
        responseType: "arraybuffer",
        headers: { "Content-type": "application/json", "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
      });
  };
}
